import { configureStore } from '@reduxjs/toolkit';
import cartSlice from '../Redux/cartSlice';
import authSlice from '../Redux/authSlice'
import productSlice from '../Redux/productSlice';
import orderSlice from '../Redux/orderSlice';

const store = configureStore({
  reducer: {
    cart: cartSlice,
    auth: authSlice,
    product: productSlice,
    order: orderSlice,
  },
});

export default store;
